import { Observable } from 'rxjs';

import { Version } from 'app/model/machine-learning/version';
import { RestfulApiService } from 'app/services/restful-api.service';

class VersionsService extends RestfulApiService<Version> {
    public increment(): Observable<void> {
        return this.http.post(`${this.getUrl()}/increment`);
    }

    public export(version: Version): Observable<void> {
        return this.http.post(`${this.getUrl()}/export/${version.version}`);
    }
    protected getFormName(): string {
        return '';
    }

    protected getPath(): string {
        return 'ml/versions';
    }
}

export const versionsService = new VersionsService();
